"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var calcPrimarySurveyorOptions_exports = {};
__export(calcPrimarySurveyorOptions_exports, {
  calcPrimarySurveyorOptions: () => calcPrimarySurveyorOptions
});
module.exports = __toCommonJS(calcPrimarySurveyorOptions_exports);
var import_topo_form = require("@cartographerio/topo-form");
var import_fp = require("@cartographerio/fp");
var import_types = require("@cartographerio/types");
var import_util = require("@cartographerio/util");
function calcPrimarySurveyorOptions(props) {
  const { users, teams, initialSurveyor, primarySurveyor, primaryTeamId } = props;
  const selectedSection = {
    heading: "Current Surveyor",
    options: arrayify(userRefToOption(primarySurveyor, "Current Surveyor", "current-user"))
  };
  const seenUserIds = new Set(primarySurveyor?.userId != null ? [primarySurveyor.userId] : []);
  const teamSections = teams.map((team) => [
    team.id,
    {
      heading: team.name,
      options: users.filter(({ roles }) => roles.some((role) => (0, import_types.roleGte)(role, (0, import_types.teamSurveyorRole)(team.id)))).map((user) => {
        seenUserIds.add(user.id);
        return userToOption(user, team.id);
      })
    }
  ]);
  const selectedTeamSection = teamSections.find(([id]) => id === primaryTeamId)?.[1];
  const otherTeamSections = (0, import_util.filterAndMap)(teamSections, ([id, section]) => id !== primaryTeamId ? section : null);
  const restSection = {
    heading: "Other Users",
    options: users.filter(({ id }) => !seenUserIds.has(id)).map((user) => userToOption(user, "other-users"))
  };
  const originalSection = {
    heading: "Original Surveyor",
    options: initialSurveyor?.userId != null && seenUserIds.has(initialSurveyor.userId) ? [] : arrayify(userRefToOption(initialSurveyor, "Original Surveyor", "original-user"))
  };
  return [
    selectedSection,
    originalSection,
    ...selectedTeamSection != null ? [selectedTeamSection] : [],
    ...otherTeamSections,
    restSection
  ].filter(({ options: items }) => items.length > 0);
}
function userRefToOption(ref, description, keyPrefix) {
  return ref?.userId == null ? null : (0, import_topo_form.selectOption)(
    ref.userId,
    ref.screenName ?? `User ${ref.userId} (${description})`,
    import_fp.Option.wrap(ref.userId).nullMap((id) => keyPrefix != null ? `${keyPrefix}.${id}` : id).getOrUndefined()
  );
}
function userToOption(user, keyPrefix) {
  return {
    label: user.screenName,
    value: user.id,
    key: keyPrefix != null ? `${keyPrefix}.${user.id}` : user.id
  };
}
function arrayify(value) {
  return value == null ? [] : [value];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  calcPrimarySurveyorOptions
});
//# sourceMappingURL=calcPrimarySurveyorOptions.js.map
